<template>
  <div class="progress-bar-container" role="presentation">
    <button class="btn finish-btn main-background secondary-text"
            @click="finishTour"
            v-if="this.poiIndex === this.poiList.length && this.tour">
      {{ $t('button.finishTour') }}
    </button>
    <div v-else class="wrapper-block">
      <div class="progress-bar">
        <div class="inner-bar main-background" v-bind:style="{width: `${progressWidth}%`}">
          <img :src="logo" alt="">
        </div>
      </div>
      <span>{{ poiIndex }}/{{ this.poiList.length }} <br class="mobile-visible">{{ $t('message.stops') }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'ProgressBar',
  data: function () {
    return {
      deviceType: ''
    }
  },
  created () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
      this.deviceType = 'ios'
    } else if (userAgent.match(/Android/i)) {
      this.deviceType = 'android'
    }
  },
  computed: {
    poiIndex: function () {
      return this.poiList.findIndex(x => x.id === this.poi.id) + 1
    },
    progressWidth: function () {
      return this.poiIndex / this.poiList.length * 100
    },
    ...mapState('poi', {
      poi: state => state.currentPoi,
      poiList: state => state.currentPoiList,
      tour: state => state.currentTour
    }),
    ...mapState({
      logo: state => state.college.settings.progress.bar_logo
    })
  },
  methods: {
    ...mapMutations('poi', ['clearCurrentTour', 'clearUnfinishedTour']),
    finishTour () {
      this.clearCurrentTour()
      this.clearUnfinishedTour()
      this.$router.push({ name: 'Congratulations' })
    }
  }
}
</script>
